<div class="details-section">
  <h4 class="details-section__title">{{ sectionTitle() }}</h4>
  <ng-content />
</div>
